<template>
    <SubPageHeader />
    <ContactContainer
        class="mt-40"
    />
    <PageFooter />
</template>

<script>
import SubPageHeader from '../components/SubPageHeader.vue'
import ContactContainer from '../components/ContactContainer.vue';
import PageFooter from '../components/PageFooter.vue';

export default {
    name: 'App',
    components: {
        SubPageHeader,
        ContactContainer,
        PageFooter,
    }
}
</script>